import { Avatar, Flex, Header, MobileStickyButton, Text } from '@components';
import { useProductDetailsQuery } from '@features/api/productsSlice';
import { useUserQuery } from '@features/api/userSlice';
import { useEffect } from 'react';
import { useTheme } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useNavigate, useParams } from 'react-router-dom';
import {
  ContentContainer,
  StyledHeaderContainer,
} from './SubscriptionIntro.styles';

const SubscriptionIntro: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const { productId } = useParams();

  const { data: user, isLoading: isLoadingUser } = useUserQuery();
  const { data: productDetails } = useProductDetailsQuery(
    { productId: productId ?? '' },
    { skip: !productId }
  );

  useEffect(() => {
    if (!user && !isLoadingUser) {
      navigate('/login', { replace: true });
    }
  }, [isLoadingUser, navigate, user]);

  const handleContinueClick = (): void => {
    navigate(`/investment-subscription/${productId}/amount`, {
      state: {
        progress: 0,
      },
    });
  };

  if (!user || !productDetails) return <></>;

  return (
    <Flex flexDirection='column' gap={15}>
      <StyledHeaderContainer>
        <Header
          user={user}
          title={{ name: <FormattedMessage id='misc.products' />, to: '/' }}
          subtitles={[
            { name: productDetails?.productName, to: `/product/${productId}` },
            { name: <FormattedMessage id='product.invest' />, to: '' },
          ]}
        />
      </StyledHeaderContainer>
      <ContentContainer>
        <Avatar user={{ ...user.basicDetails, avatar: user.avatar }} />
        <Text variant='h3' fontWeight='fontWeightBold' marginTop={17}>
          <FormattedMessage
            id='investment.subscriptionIntro.title'
            values={{
              firstName: user?.basicDetails.firstName,
            }}
          />
        </Text>
        <Text
          variant='h6'
          fontWeight='fontWeightMedium'
          sx={{ color: theme.palette.black[500], mt: 6 }}
        >
          <FormattedMessage id='investment.subscriptionIntro.description' />
        </Text>
        <Flex flex={0} marginY={17}>
          <MobileStickyButton
            data-testid='get-started-button'
            variant='primary'
            size='large'
            onClick={handleContinueClick}
          >
            <FormattedMessage id='misc.getStarted' />
          </MobileStickyButton>
        </Flex>
      </ContentContainer>
    </Flex>
  );
};

export default SubscriptionIntro;
